import React from "react";
import { useLanguage } from "../../../Providers/LanguageContext";
import ExpenseChart from "./ExpenseChart";
import ExpenseLineChart from "./ExpenseLineChart/ExpenseLineChart";
import SalesLineChart from "./SalesLineChart/SalesLineChart";
import ProfitLineChart from "./ProfitLineChart/ProfitLineChart";
// import { useSelector } from 'react-redux'
import { useLocation } from "react-router-dom";
function DashboardChartFourColumn({
  data,
  expenseData,
  salesData,
  profitData,
  time,
  setExpenseFilter,
  setSalesFilter,
  setProfitFilter,
  expenseBarChart,
  expenseLineChart,
  salesLineChart,
  profitLineChart,
  selectedYearFromDashboardPage,
}) {
  const { language } = useLanguage();
  // const { expenseBarChart, salesLineChart, expenseLineChart, profitLineChart } = useSelector(state => state?.favDashboard);
  const location = useLocation();
  console.log(data, "DATACOLUMN");
  // console.log("profitLineChart:>>>>>>>>>>>> ", profitLineChart);
  console.log("Redux state in DashboardChartFourColumn:", {
    expenseBarChart,
    salesLineChart,
    expenseLineChart,
    profitLineChart,
  });

  if (location.pathname === "/dashboard-manager") {
    return (
      <div
      // className='row justify-content-md-center mt-5'
      >
        <div
          className="bar-line-wrp"
          // className="col-sm-12 col-md-6 col-lg-4"
        >
          <div className="chart-adjust-div">
            <ExpenseChart data={data} text={language.expense} />
          </div>
          <div className="chart-adjust-div">
            <ExpenseLineChart
              data={expenseData}
              time={time}
              setFilter={setExpenseFilter}
              selectedYearFromDashboardPage={selectedYearFromDashboardPage}
            />
          </div>
        </div>
        <div
          className="bar-line-wrp"
          // className="col-sm-12 col-md-6 col-lg-4"
        >
          <div className="chart-adjust-div">
            <ExpenseChart data={data} text={language.sales} />
          </div>
          <div className="chart-adjust-div">
            <SalesLineChart
              data={salesData}
              time={time}
              setFilter={setSalesFilter}
            />
          </div>
        </div>
        <div
          className="bar-line-wrp"
          // className="col-sm-12 col-md-6 col-lg-4"
        >
          <div className="chart-adjust-div">
            <ExpenseChart data={data} text={language.profit} />
          </div>

          <div className="chart-adjust-div">
            <ProfitLineChart
              data={profitData}
              time={time}
              setFilter={setProfitFilter}
            />
          </div>
        </div>
      </div>
    );
  }
  // For favorite dashboard widgets
  if (location.pathname !== "/dashboard-manager") {
    // Return the appropriate chart based on which Redux state is true
    if (expenseBarChart) {
      return (
        <div>
          <div className="bar-line-wrp" style={{ width: "100%" }}>
            <div
              className="chart-adjust-div"
              style={{ width: "100%", minWidth: "100%", maxWidth: "100%" }}
            >
              <ExpenseChart data={data} text={language.expense} />
            </div>
          </div>
        </div>
      );
    } else if (expenseLineChart) {
      return (
        <div>
          <div className="bar-line-wrp" style={{ width: "100%" }}>
            <div
              className="chart-adjust-div"
              style={{ width: "100%", minWidth: "100%", maxWidth: "100%" }}
            >
              <ExpenseLineChart
                data={expenseData}
                time={time}
                setFilter={setExpenseFilter}
              />
            </div>
          </div>
        </div>
      );
    } else if (salesLineChart) {
      return (
        <div>
          <div className="bar-line-wrp" style={{ width: "100%" }}>
            <div
              className="chart-adjust-div"
              style={{ width: "100%", minWidth: "100%", maxWidth: "100%" }}
            >
              <SalesLineChart
                data={salesData}
                time={time}
                setFilter={setSalesFilter}
              />
            </div>
          </div>
        </div>
      );
    } else if (profitLineChart) {
      return (
        <div>
          <div className="bar-line-wrp" style={{ width: "100%" }}>
            <div
              className="chart-adjust-div"
              style={{ width: "100%", minWidth: "100%", maxWidth: "100%" }}
            >
              <ProfitLineChart
                data={profitData}
                time={time}
                setFilter={setProfitFilter}
              />
            </div>
          </div>
        </div>
      );
    } else {
      // Default fallback - render all charts
      return (
        <div>
          <div className="bar-line-wrp" style={{ width: "100%" }}>
            <div
              className="chart-adjust-div"
              style={{ width: "100%", minWidth: "100%", maxWidth: "100%" }}
            >
              <ExpenseChart data={data} text={language.expense} />
            </div>
          </div>
        </div>
      );
    }
  }
}

export default DashboardChartFourColumn;
